import { render, staticRenderFns } from "./KeyMedia.vue?vue&type=template&id=4fa4d5c5&"
import script from "./KeyMedia.vue?vue&type=script&lang=js&"
export * from "./KeyMedia.vue?vue&type=script&lang=js&"
import style0 from "./KeyMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports